<template>
    <el-dialog
        :visible.sync="display"
        :append-to-body="true"
        :title="`${getVerbose('user_modal_manage_user_roles_title_beginning')} ${user.email} ${getVerbose('user_modal_manage_user_roles_title_end')}`"
        width="60%"
        class="modal-manage-user-role"
        @close="onClose"
    >
        <el-transfer
            v-model="selectedRoles"
            :data="concreteRoles"
            :titles="[getVerbose('user_modal_manage_user_roles_transfer_from'), getVerbose('user_modal_manage_user_roles_transfer_to')]"
            :props="{
                key: 'uid',
                label: getVerbose('user_modal_manage_user_roles_transfer_label')
            }"
        ></el-transfer>
        <span slot="footer">
            <el-button @click=" display = false">{{ getVerbose('user_modal_manage_user_roles_button_close') }}</el-button>
            <el-button type="primary" @click="manageUserRoles">{{ getVerbose('user_modal_manage_user_roles_button_save') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
export default {

    components: {

    },

    props: {

    },

    data (){
        return {
            display: false,
            user: {},
            selectedRoles: [],
        };
    },

    computed: {
        ...mapGetters([
            'concreteRoles'
        ]),
        ...mapGetters('fundation', [
            'getVerbose'
        ]),
    },

    methods: {
        init (user){
            this.$set(this, 'user', user);
            for(let role of this.concreteRoles){
                if(role.users_uid.includes(user.uid)){
                    this.selectedRoles.push(role.uid);
                }
            }
            this.display = true;
        },
        close (){
            this.display = false;
        },
        manageUserRoles (){
            let promises = [];
            for(let role of this.concreteRoles){
                let usersInRole = JSON.parse(JSON.stringify(role.users_uid));
                if(
                    role.users_uid.includes(this.user.uid) &&
                    !this.selectedRoles.includes(role.uid)
                ){
                    // signifie que le role à été enlever du transfert alors qu'il étais présent de base
                    usersInRole.splice(usersInRole.indexOf(this.user.uid), 1);
                }else if (
                    !role.users_uid.includes(this.user.uid) &&
                    this.selectedRoles.includes(role.uid)
                ){
                    usersInRole.push(this.user.uid);
                }else{
                    continue;
                }
                promises.push(this.$store.dispatch('patchItem', {
                    item: {
                        url: role.url,
                        users_uid: usersInRole,
                    },
                    model: 'concreteRoles'
                }));
            }
            Promise.all(promises).then(() => {
                this.$notify.success({title: this.getVerbose('user_modal_manage_user_roles_success_title'), message: this.getVerbose('user_modal_manage_user_roles_success_message')});
                this.display = false;
            }).catch(() => {
                this.$notify.error({title: this.getVerbose('user_modal_manage_user_roles_failure_title'), message: this.getVerbose('user_modal_manage_user_roles_failure_message')});

            });
        },

        onClose (){
            this.$set(this, 'selectedRoles', []);
            this.$set(this, 'user', {});

        }
    },
};
</script>

<style lang="scss">
.modal-manage-user-role{
    .el-transfer-panel{
        width: 45%;
    }
    .el-transfer__buttons{
        width: 10%;

        .el-button{
            margin: 5px auto !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/usersManagement/user/modal-manage-user-role.vue